import React from "react";
import { Box, MenuItem, Select, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";
import { ChevronUpDownIcon } from "../../../../common/Icons/Icons";

const BasicSelectWithTag = () => {
  const [age, setAge] = React.useState(10);

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"Select with tag"}
        language={"js"}
        value={"" +
            "     <Select\n" +
            "          width={200}\n" +
            "          value={age}\n" +
            "          onChange={handleChange}\n" +
            "          IconComponent={ChevronUpDownIcon}\n" +
            "        >\n" +
            "          <MenuItem value={10}>\n" +
            "            <Typography component={\"span\"} sx={{ fontSize: 14 }}>\n" +
            "              Default\n" +
            "            </Typography>\n" +
            "            <Typography\n" +
            "              sx={{ fontSize: 13, color: \"text.tertiary\", ml: 1 }}\n" +
            "              component={\"span\"}\n" +
            "              variant=\"body2\"\n" +
            "            >\n" +
            "              @tomcook\n" +
            "            </Typography>\n" +
            "          </MenuItem>\n" +
            "          <MenuItem value={20}>Twenty</MenuItem>\n" +
            "          <MenuItem value={30}>Thirty</MenuItem>\n" +
            "        </Select>\n" +
            "\n\n\n" +
            "        <Select\n" +
            "          width={200}\n" +
            "          value={age}\n" +
            "          onChange={handleChange}\n" +
            "          size=\"small\"\n" +
            "          IconComponent={ChevronUpDownIcon}\n" +
            "        >\n" +
            "          <MenuItem value={10}>\n" +
            "            <Typography component={\"span\"} sx={{ fontSize: 14 }}>\n" +
            "              Small\n" +
            "            </Typography>\n" +
            "            <Typography\n" +
            "              sx={{ fontSize: 13, color: \"text.tertiary\", ml: 1 }}\n" +
            "              component={\"span\"}\n" +
            "              variant=\"body2\"\n" +
            "            >\n" +
            "              @tomcook\n" +
            "            </Typography>\n" +
            "          </MenuItem>\n" +
            "          <MenuItem value={20}>Twenty</MenuItem>\n" +
            "          <MenuItem value={30}>Thirty</MenuItem>\n" +
            "        </Select>"}
      >
        <Select
          width={200}
          value={age}
          onChange={handleChange}
          IconComponent={ChevronUpDownIcon}
        >
          <MenuItem value={10}>
            <Typography component={"span"} sx={{ fontSize: 14 }}>
              Default
            </Typography>
            <Typography
              sx={{ fontSize: 13, color: "text.tertiary", ml: 1 }}
              component={"span"}
              variant="body2"
            >
              @tomcook
            </Typography>
          </MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>

        <Select
          width={200}
          value={age}
          onChange={handleChange}
          size="small"
          IconComponent={ChevronUpDownIcon}
        >
          <MenuItem value={10}>
            <Typography component={"span"} sx={{ fontSize: 14 }}>
              Small
            </Typography>
            <Typography
              sx={{ fontSize: 13, color: "text.tertiary", ml: 1 }}
              component={"span"}
              variant="body2"
            >
              @tomcook
            </Typography>
          </MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicSelectWithTag;
